import type { ReferencedEntry } from 'contentful';
import React from 'react';

import type { HasImage, HasVideo, Subject } from 'api/contentful/contentTypes.cloverdotcom';
import { withSidebarContext } from 'components/SidebarContext/WithSidebarContext';
import { TextMediaModulePresentational } from 'components/TextMediaModule/TextMediaModule';

import { VerticalMenuTrigger } from '../../VerticalMenuTrigger/VerticalMenuTrigger';

import featureStyles from './featureHero.module.scss';
import homepageStyles from './homepageHero.module.scss';
import { HERO_MODULE_TEST_ID } from './HeroModule.const';

type HeroModuleProps = {
  mediaOverride?: ReferencedEntry<HasVideo | HasImage>;
  heroTopic?: ReferencedEntry<Subject>;
  isHomepage?: boolean;
};

class HeroModule extends React.PureComponent<HeroModuleProps> {
  render() {
    const { heroTopic, mediaOverride, isHomepage } = this.props;

    if (!heroTopic || !heroTopic.fields) return null;

    if (isHomepage) {
      return (
        <VerticalMenuTrigger threshold={0.65}>
          {({ ref }) => (
            <TextMediaModulePresentational
              data-testid={HERO_MODULE_TEST_ID.pageHero}
              topic={heroTopic}
              mediaOverride={mediaOverride}
              wrapperRef={ref}
              className={homepageStyles.homepageHero}
              containerClassName={homepageStyles.container}
              mediaClassName={homepageStyles.media}
              textBlockClassName={homepageStyles.text}
              titleTagName="h1"
              data-content-type={heroTopic.sys.contentType.sys.id}
              data-entry-id={heroTopic.sys.id}
            />
          )}
        </VerticalMenuTrigger>
      );
    }

    return (
      <TextMediaModulePresentational
        topic={heroTopic}
        className={featureStyles.hero}
        containerClassName={featureStyles.container}
        mediaClassName={featureStyles.media}
        textBlockClassName={featureStyles.text}
        blurbClassName={featureStyles.blurb}
        titleTagName="h1"
        data-content-type={heroTopic.sys.contentType.sys.id}
        data-entry-id={heroTopic.sys.id}
      />
    );
  }
}

const SidebarContexted = withSidebarContext(({ media }) => ({
  mediaOverride: media,
}))(HeroModule);

export { SidebarContexted as HeroModule, HeroModule as _HeroModule };
